import { withStyles, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { compose } from 'recompose';
const styles = (theme) => ({
  dialog: {
    maxWidth: 650,
    height: '85%',
    flex: 1,
    backgroundColor: theme.ModalBGColor
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12 20 12 20',
    borderBottom: `1px solid ${theme.scrollThumbColor}`
  },
  dialogContent: {
    padding: '0 20 20 20',
    display: 'flex',
    flexDirection: 'column'
  },
  titleText: {
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
    lineHeight: '19px',
    color: theme.palette.primary.main
  },
  closeButton: {
    cursor: 'pointer',
    color: theme.iconColor
  },
});

const DialogBox = ({ classes, children, handleClose, userData }) => {
  const { theme } = userData.userProfile || {};
  return (
    <Dialog
      aria-labelledby="message-history"
      open
      classes={{
        paper: classes.dialog
      }}
      className={`${classes.dialogWrapper} ${theme}`}>
      <DialogTitle
        disableTypography
        handleClose={handleClose}
        classes={{ root: classes.dialogTitle }}>
        <span className={classes.titleText}>
          Message History
        </span>
        <span onClick={handleClose} className={classes.closeButton}>
          <CloseIcon />
        </span>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>{children}</DialogContent>
    </Dialog>
  );
};

export default compose(withStyles(styles), withUserProfile)(DialogBox);
